import React, { useEffect } from "react";
import { getGlobalData, getPageData } from "utils/api";
import MainLayout from "components/layouts/mainLayout";
import ErrorPage from "next/error";
import { Mixpanel } from "utils/mixpanel";
import { useRouter } from "next/router";
import Seo from "components/Seo";
import Sections from "components/sections/sections";

// const Resources = () => {
//   return (
//     <TabsProvider>
//       <HeroSection
//         title={"Resources"}
//         imageURL={{ desktop: RESOURCE_ICON, mobile: HERO_MOBILE }}
//         subTitle={
//           " One Farmer at a time, telling our stories of building an Africa that feeds the World and itself."
//         }
//       />
//       <Tab
//         // setCurrentTab={setCurrentTab}
//         // currentTab={currentTab}
//         data={resourcesTab}
//         location="resources"
//         stickySection="tab-section"
//         defaultTab={resourcesTab[0].path}
//       >
//         {renderWithTabContentWrapper(resourcesTab)}
//       </Tab>
//     </TabsProvider>
//   );
// };

const Resources = ({
  sections,
  metadata,
  preview,
  global,
  pageContext,
  pageData,
}) => {
  const router = useRouter();

  // Check if required data was provided
  if (!router.isFallback && !sections?.length) {
    return <ErrorPage statusCode={404} />;
  }

  // Loading screen (only possible in preview mode)
  if (router.isFallback) {
    return <div className="container">Loading...</div>;
  }

  // Merge default site SEO settings with page specific SEO settings
  if (metadata.shareImage?.data == null) {
    delete metadata.shareImage;
  }
  const metadataWithDefaults = {
    ...global.attributes.metadata,
    ...metadata,
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const trackPageHit = () => {
      Mixpanel.track(pageData.title, { localeInfo: pageContext, pageData });
    };
    trackPageHit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* add meta tags for seo */}
      <Seo metadata={metadataWithDefaults} />
      {/* Display content Sections */}
      <Sections sections={sections} preview={preview} />
    </>
  );
};
Resources.Layout = MainLayout;
export default Resources;

export async function getServerSideProps() {
  const globalData = await getGlobalData("en");
  const pageData = await getPageData({ full_slug: "/resources" });

  if (!pageData) {
    return {
      props: {},
      redirect: { destination: "/resources/hectare", permanent: false },
    };
  }
  const {
    contentSections,
    metadata,
    localizations,
    slug,
    full_slug,
    ...pageExtraData
  } = pageData.attributes;

  const pageContext = {
    locale: "en",
    locales: "en",
    defaultLocale: "en",
    slug,
    localizations,
    full_slug,
  };

  return {
    props: {
      sections: contentSections,
      metadata,
      global: globalData,
      pageData: { ...pageExtraData },
      pageContext: {
        ...pageContext,
      },
    },
  };
}
